"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.headerHeight = void 0;
var material_1 = require("@mui/material");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var React = __importStar(require("react"));
var LayoutContext_1 = require("../LayoutContext");
var classnames_1 = __importDefault(require("classnames"));
var IconBtn_1 = require("../../../IconBtn/IconBtn");
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
exports.headerHeight = 52;
var useStyles = (0, makeStyles_1.default)(function (t) { return (0, createStyles_1.default)({
    root: {
        height: exports.headerHeight,
        display: 'flex',
        alignItems: 'center',
        paddingRight: t.spacing(2),
        paddingLeft: t.spacing(1) + 2,
        background: t.palette.background.paper,
    },
    hidden: {
        visibility: 'hidden',
    },
    title: {
        flex: 1,
        fontSize: t.typography.h6.fontSize,
    }
}); });
var Header = function (_a) {
    var className = _a.className;
    var classes = useStyles();
    var _b = (0, LayoutContext_1.useLayoutContext)(), title = _b.title, isMobileWidth = _b.isMobileWidth, isMobileSidebarOpened = _b.isMobileSidebarOpened, toggleMobileSidebar = _b.toggleMobileSidebar;
    return (React.createElement("header", { className: (0, classnames_1.default)(classes.root, className) },
        React.createElement(IconBtn_1.IconBtn, { onClick: toggleMobileSidebar, className: isMobileWidth ? '' : classes.hidden },
            React.createElement(material_1.Icon, null, isMobileSidebarOpened ? 'clear' : 'menu')),
        React.createElement("div", { className: classes.title }, title)));
};
exports.Header = Header;
//# sourceMappingURL=Header.js.map